import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import useMultipleModals from '../../../../hooks/useMultipleModals';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import FluidLeftLayout from '../../../layouts/FluidLeftLayout';
import Dependency from '../Licensing/Dependency';
import FileMatches from '../Licensing/FileMatches';
import IssueDetails from '../Licensing/IssueDetails';
import Licenses from '../Licensing/Licenses';
import ResolvedReason from '../ResolvedReason';

/**
 * A component that renders the detailed content of a licensing issue in a full-page layout.
 */
const LicensingIssueDetailContent: VoidFunctionComponent = () => {
  //  Normally in the drawer there are multiple modals, but here it's just the licenses one.
  const { viewLicenseModal } = useMultipleModals('viewLicense');
  const isUnlicensedIssue = useSelector(IssuesV2Store.selectors.getIsIssueDetailsUnlicensed);

  //  For unlicensed issues, we hide the FileMatches and Licenses sections.
  //  Because of this, it doesn't really make sense to render the fluid-left layout,
  //  so we instead just render it all in the main section like we do for Quality issues.
  if (isUnlicensedIssue) {
    return (
      <>
        <ResolvedReason />
        <IssueDetails />
        <Dependency />
      </>
    );
  }

  return (
    <FluidLeftLayout>
      <FluidLeftLayout.Left>
        <ResolvedReason />
        <IssueDetails />
        <FileMatches minHeight="800px" />
      </FluidLeftLayout.Left>
      <FluidLeftLayout.Right>
        <Licenses viewLicenseModal={viewLicenseModal} />
        <Dependency />
      </FluidLeftLayout.Right>
    </FluidLeftLayout>
  );
};

export default LicensingIssueDetailContent;
